import { Button, PinInput, Stack } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { useTwoFactorFormContext } from '../../../contexts/forms';

import { BaseFormProps } from '../../../@types/global';

export default function TwoFactorForm({
  onSubmit,
  isSubmitting = false,
}: BaseFormProps) {
  const form = useTwoFactorFormContext();
  const navigate = useNavigate();

  /*
    The following function fixes a bug in Mantine's PinInput component
    where pasting a value into the input field does not work as expected.

    This bug occurs when the value in the clipboard has whitespace or a
    line break.

    Therefore, we need to trim the value before setting it
    in the input field.

    Bug has been filed with Mantine here:
    https://github.com/mantinedev/mantine/issues/5340

    If/When this is fixed from Mantine's side, we can remove this function.
  */
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const copyValue = e.clipboardData.getData('Text').trim();
    const isValid = /^[0-9]+$/.test(copyValue);

    if (isValid) {
      form.setValues({ otp: copyValue });
    }
  };

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack align="center">
        <PinInput
          oneTimeCode
          type="number"
          length={6}
          size="lg"
          disabled={isSubmitting}
          onPaste={handlePaste}
          {...form.getInputProps('otp')}
        />
        <Stack align="center">
          <Button type="submit" loading={isSubmitting} w={200}>
            Verify
          </Button>
          <Button variant="subtle" w={200} onClick={() => navigate('/login')}>
            Cancel
          </Button>
        </Stack>
      </Stack>
    </form>
  );
}
